import lrCodeMirror from './_src/lrCodeMirror.vue'

lrCodeMirror.install = function(Vue) {
  Vue.component(lrCodeMirror.name, lrCodeMirror)
}

export default lrCodeMirror